import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { notification, theme } from 'antd';
import { HiDocumentText } from 'react-icons/hi';
import FormPublisher from '../../components/clinicalForms/FormPublisher.component';
import { updateForm, getFormDetails } from '../../actions/formActions';
import useDocumentTitle from '../../utils/useDocumentTitle';
import PageWrapper from '../../components/common/PageWrapper';

/**
 * Edit Clinical Form Screen
 * Handles editing of existing clinical forms using the publisher component
 */
const FormEditScreen = () => {
  const dispatch = useDispatch();
  const { token } = theme.useToken();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const defaultEntityType = searchParams.get('entityType');
  useDocumentTitle('Edit Form');

  // Redux state variables
  const formDetails = useSelector((state) => state.formDetails);
  const { loading: loadingDetails, form: formData } = formDetails;

  const formUpdate = useSelector((state) => state.formUpdate);
  const { loading: loadingUpdate, error: errorUpdate, success: successUpdate } = formUpdate;

  // Handle success - stay on current page
  useEffect(() => {
    if (successUpdate) {
      notification.success({ message: 'Form updated successfully' });
      dispatch({ type: 'FORM_UPDATE_RESET' });
    }
  }, [successUpdate, dispatch]);

  // Load form details on mount
  useEffect(() => {
    if (id) {
      dispatch(getFormDetails(id));
    }
    return () => {
      dispatch({ type: 'FORM_DETAILS_RESET' });
    };
  }, [id, dispatch]);

  const handleUpdateForm = (formId, payload) => {
    dispatch(updateForm(formId, payload));
  };

  const handleGetFormDetails = (formId) => {
    dispatch(getFormDetails(formId));
  };

  return (
    <PageWrapper
      title="Edit Form"
      icon={<HiDocumentText style={{ fontSize: 24, color: token.colorPrimary }} />}
    >
      <FormPublisher 
        formId={id}
        defaultEntityType={defaultEntityType}
        loadingDetails={loadingDetails}
        loadingUpdate={loadingUpdate}
        errorUpdate={errorUpdate}
        formDetails={formData}
        onUpdateForm={handleUpdateForm}
        onGetFormDetails={handleGetFormDetails}
        showBackButton={false}
        showPadding={false}
      />
    </PageWrapper>
  );
};

export default FormEditScreen;

